// extracted by mini-css-extract-plugin
export default {"logo":"nav_logo__xFXM-","longMenuItem":"nav_longMenuItem__xxHHg"};